import { isAfter } from 'date-fns';

const limitDateRange = (current: Date) => current && isAfter(current, new Date());

export default limitDateRange;
